import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'

//Import components
import { ArrowBlock } from '@jelly/components'
import { Link } from '@jelly/ui'

//Styled components
const Wrapper = styled(Link)`
	max-width: 100%;
	height: 200px;
	text-align: center;
	cursor: pointer;
	position: relative;
	${({ gridBrowserSupport }) => gridBrowserSupport};

	&:hover {
		.arrowBlock {
			background: ${({ theme }) => theme.colors.teal};
		}
	}

	${({ theme }) => theme.MQ.M} {
		text-align: left;
	}
`
const ContentWrapper = styled.div`
	vertical-align: middle;
	padding: 20px;

	${({ theme }) => theme.MQ.M} {
		padding: 40px 20px;
	}
	@media (min-width: 768px) and (max-width: 770px) {
		padding: 20px;
	}
`
const TitleWrapper = styled.div`
	${({ theme }) => theme.header.h3};
	color: #ffffff;
	padding: 10px 20px;
`
const DescriptionWrapper = styled.div`
	${({ theme }) => theme.text.bodySmall};
	color: #ffffff;
	padding: 0 20px 10px 20px;

	${({ theme }) => theme.MQ.M} {
		max-width: 75%;
	}
`

CardLongSimple.propTypes = {
	description: string,
	gridBrowserSupport: string,
	title: string,
	url: string,
}

/**
 * This Component is the Long Card
 * It takes in Background color, Title, Description and Link
 * On Hover: salman arrow button turns teal
 */
function CardLongSimple({ gridBrowserSupport, title, description, url }) {
	return (
		<Wrapper href={url} gridBrowserSupport={gridBrowserSupport}>
			<ContentWrapper>
				<TitleWrapper>{title}</TitleWrapper>
				<DescriptionWrapper>{description}</DescriptionWrapper>
				<ArrowBlock />
			</ContentWrapper>
		</Wrapper>
	)
}

export default CardLongSimple
